<div class="container">
    <mat-form-field>
        <mat-label>Centre</mat-label>
        <mat-select [(ngModel)]="selectedCentre" (selectionChange)="onCentreChange($event)">
            <mat-option *ngFor="let c of centres$|async" [value]="c.centreCode">{{c.centreName}}</mat-option>
            <mat-option value="All"> All Centres</mat-option>
        </mat-select>
    </mat-form-field>


    <div class="card">
        <div class="ngxTableHeader">
            <ul class="header-buttons-left ms-0 mb-0">
                <li class="dropdown">
                    <!--          <h2>Child List</h2>-->
                </li>
                <li class="dropdown m-l-20">
                    <label for="search-input"><i class="material-icons search-icon">search</i></label>
                    <input placeholder="Search" id="search-input" type="text" class="browser-default search-field"
                           (keyup)='applyFilter($event)' aria-label="Search box" #input>
                </li>
            </ul>
            <ul class="header-buttons mr-2">
                      <li>
                        <button   mat-mini-fab color="primary" (click)="addLog()">
                          <mat-icon class="col-white" >add</mat-icon>
                        </button>
                      </li>
                <!--        <li>-->
                <!--          <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()">-->
                <!--            <img src="assets/images/icons/xlsx.png" alt="" />-->
                <!--          </div>-->
                <!--        </li>-->
            </ul>
        </div>

        <table mat-table [dataSource]="dataSource" matSort>


            <ng-container matColumnDef="centreName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Centre</th>
                <td mat-cell *matCellDef="let element"> {{ element.centreName }} </td>
            </ng-container>
            <ng-container matColumnDef="conductedBy">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Conducted By</th>
                <td mat-cell *matCellDef="let element"> {{ element.conductedBy }} </td>
            </ng-container>
            <ng-container matColumnDef="sessionType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Type</th>
                <td mat-cell *matCellDef="let element"> {{ element.sessionType }} </td>
            </ng-container>
            <ng-container matColumnDef="floor">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Floor</th>
                <td mat-cell *matCellDef="let element"> {{ element.floor }} </td>
            </ng-container>

            <ng-container matColumnDef="topicsCovered">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Topics Covered</th>
                <td mat-cell *matCellDef="let element"> {{ element.topicsCovered }} </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let element" [matTooltip]="element.remark"> {{ element.status }} </td>
            </ng-container>
            <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
                <td mat-cell *matCellDef="let element"> {{ element.createdAt.toDate()|date:'dd-MM-yyyy' }} </td>
            </ng-container>

            <ng-container matColumnDef="sessionDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Date</th>
                <td mat-cell *matCellDef="let element"> {{ element.sessionDate.toDate()|date:'dd-MM-yyyy' }} </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                <td mat-cell *matCellDef="let element">
                <button mat-raised-button color="accent" *ngIf="element.status=='Pending' && (userRole!='Counseller')"  (click)="changeStatus(element)">{{element.status}}</button>
                <button mat-raised-button color="primary" *ngIf="element.status!='Pending'"  (click)="changeStatus(element)">{{element.status}}</button>
                <button mat-icon-button color="warn" *ngIf="element.conductedBy==this.userName"  (click)="delete(element)"><mat-icon>delete</mat-icon></button>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>

    </div>


</div>
